import { createProfessionalExporter } from '../../../utils/professionalExport';

const headers = ['Name', 'Email', 'Phone', 'Branch', 'Shift', 'Status'];

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

const exporter = createProfessionalExporter({
  title: 'Receptionist List',
  headers,
  slug: 'receptionists',
  getRows: (list) =>
    list.map((r) => [
      r.name,
      r.email,
      r.phone,
      r.branch,
      r.shift,
      formatStatus(r.status),
    ]),
  getSummary: (list) => [
    `Total receptionists: ${list.length}`,
    `Active: ${list.filter((r) => r.status === 'active').length}`,
  ],
});

export const printReceptionistList = (data) => exporter.print(data);
export const exportReceptionistCsv = (data) => exporter.csv(data);
export const exportReceptionistExcel = (data) => exporter.excel(data);
export const exportReceptionistPdf = (data) => exporter.pdf(data);
export const exportReceptionists = (data) => exporter.export(data);
